var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bubble-maps-page"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"flex md12 xs12"},[_c('va-card',{staticClass:"bubble-maps-page__widget",attrs:{"title":"Bubble Maps"}},[_c('bubble-map',{staticStyle:{"height":"65vh"},attrs:{"map-data":_vm.bubbleMapData}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }